<template>
    <div class="com-container">
        <div class="com-chart" ref="seller_erf"></div>
    </div>
</template>
<script>
// 实验柱状
export default {
    data() {
        return {
            chartInstance: null,
            allDate: null, // 服务器返回的数据
            startValue: 0, //区域缩放起点
            endValue: 4, // 区域缩放终点
            timerId: null, // 定时器标识
            titleFontSize1: null,
            color: null,
            formattedTime: null,
            a:[0,10,20,30,40,50,60],
        };
    },
    mounted() {
        this.initChart();
        this.getData();
        window.addEventListener("resize", this.screenAdapter);
        this.time1()
        this.screenAdapter();

    },
    destroyed() {
        clearInterval(this.timerId);
        window.removeEventListener("resize", this.screenAdapter);
    },
    methods: {
        time1() {
            const now = new Date();
            const year = now.getFullYear();
            const month = ("0" + (now.getMonth() + 1)).slice(-2);
            const day = ("0" + now.getDate()).slice(-2);
            const hours = ("0" + now.getHours()).slice(-2);
            const minutes = ("0" + now.getMinutes()).slice(-2);
            const seconds = ("0" + now.getSeconds()).slice(-2);
            this.formattedTime =
                minutes
        },
        // 初始化echartInstance对象
        initChart() {
            this.chartInstance = this.$echarts.init(this.$refs.seller_erf, "dark");
            const initOption = {
                // title: {
                //     text: ` ▎(名称根据数据库数据遍历，动态)环境`,
                //     left: 20,
                //     top: 20,
                // },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true
                        }, lineStyle: {
                            type: "solid",
                            color: "#2D3443",
                        },
                    },
                    valueFormatter: function (value) {
                        return value + '℃'
                    }
                },
                legend: {//筛选y轴值
                    data: [`进水温度`, '出水温度'],
                    top: 50,
                    left: 40
                },
                grid: {
                    top: "40%",
                    left: "3%",
                    right: "6%",
                    bottom: "5%",
                    containLabel: true, // 包含坐标轴上的文字
                },
                xAxis: [
                    {
                        type: 'category',
                    }
                ],
                yAxis: {
                    type: "value",
                    max: 80,
                    axisTick: {
                        show: false,
                        lineStyle: {
                            // 回调函数动态返回颜色
                             color: ['#00000000','#00000000','#00000000','#00000000','#00000000','#00000000','#00000000','red','#00000000'],
                            width: 1,
                        }
                    },
                    interval: 10, // 强制间隔为10
                    splitLine: {
                        show: true, // 隐藏网格线
                        lineStyle: {
                            color:['#00000000','#00000000','#00000000','#00000000','#00000000','#00000000','#00000000','red','#00000000'],
                            width: 1,
                            type: 'solid' // 实线
                        },
                    },
                    axisLabel: {
                        formatter: "{value} °C",
                    },
                },
                dataZoom: [
                    {
                        show: false,
                        start: 80,
                        end: 100
                    },
                    {
                        type: 'inside',
                        start: 80,
                        end: 100
                    },
                ],
                series: [
                    {
                        name: '进水温度',
                        type: "bar",
                        // label: {
                        //     // 数值展示
                        //     show: true,
                        //     position: "top",
                        //     textStyle: {
                        //         color: "white",
                        //     },
                        // },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                // 百分之0状态下的颜色值
                                {
                                    offset: 0,
                                    color: "#87CEFF",
                                },
                                // 百分之10
                                // 0状态下的颜色值
                                {
                                    offset: 1,
                                    color: "#00BFFF",
                                },
                            ]),

                            // else if (arg.value > 90) {
                            //     return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //         // 百分之0状态下的颜色值
                            //         {
                            //             offset: 0,
                            //             color: "#FF8800",
                            //         },
                            //         // 百分之10
                            //         // 0状态下的颜色值
                            //         {
                            //             offset: 1,
                            //             color: "#99FF33",
                            //         },
                            //     ])
                            // } else {
                            //     return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //         // 百分之0状态下的颜色值
                            //         {
                            //             offset: 0,
                            //             color: "#55AA00",
                            //         },
                            //         // 百分之10
                            //         // 0状态下的颜色值
                            //         {
                            //             offset: 1,
                            //             color: "#66FF66",
                            //         },
                            //     ])
                            // }


                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        name: '出水温度',
                        type: "bar",
                        // label: {
                        //     // 数值展示
                        //     show: true,
                        //     position: "top",
                        //     textStyle: {
                        //         color: "white",
                        //     },
                        // },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                // 百分之0状态下的颜色值
                                {
                                    offset: 0,
                                    color: "#55AA00",
                                },
                                // 百分之10
                                // 0状态下的颜色值
                                {
                                    offset: 1,
                                    color: "#66FF66",
                                },
                            ]),
                            // arg => {
                            //     if (arg.value > 25) {
                            //         return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //             // 百分之0状态下的颜色值
                            //             {
                            //                 offset: 0,
                            //                 color: "#FF3333",
                            //             },
                            //             // 百分之10
                            //             // 0状态下的颜色值
                            //             {
                            //                 offset: 1,
                            //                 color: "#EE7700",
                            //             },
                            //         ])
                            //     } 
                            // else if (arg.value > 90) {
                            //     return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //         // 百分之0状态下的颜色值
                            //         {
                            //             offset: 0,
                            //             color: "#FF8800",
                            //         },
                            //         // 百分之10
                            //         // 0状态下的颜色值
                            //         {
                            //             offset: 1,
                            //             color: "#99FF33",
                            //         },
                            //     ])
                            // } 
                            //     else {
                            //         return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            //             // 百分之0状态下的颜色值
                            //             {
                            //                 offset: 0,
                            //                 color: "#55AA00",
                            //             },
                            //             // 百分之10
                            //             // 0状态下的颜色值
                            //             {
                            //                 offset: 1,
                            //                 color: "#66FF66",
                            //             },
                            //         ])
                            //     }
                            // },

                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    // {
                    //     name: '室外温度',
                    //     type: "bar",
                    //     // label: {
                    //     //     // 数值展示
                    //     //     show: true,
                    //     //     position: "top",
                    //     //     textStyle: {
                    //     //         color: "white",
                    //     //     },
                    //     // },
                    //     itemStyle: {
                    //         barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                    //         color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    //             // 百分之0状态下的颜色值
                    //             {
                    //                 offset: 0,
                    //                 color: "#5052EE",
                    //             },
                    //             // 百分之10
                    //             // 0状态下的颜色值
                    //             {
                    //                 offset: 1,
                    //                 color: "#AB6EE5",
                    //             },
                    //         ]),
                    //     },
                    // },
                ],
            };
            this.chartInstance.setOption(initOption);
        },
        // 获取服务器数据
        async getData() {
            const { data: ret } = await this.$http.get("sensor/getHalfHourData?sId=5,6");
            this.allDate = ret;
            this.updateChart();
            this.startInterver();
        },
        // 更新图标
        updateChart() {
            const sellerNames1 = this.allDate.map((item) => {
                return item[0].sTime.substring(11, 19)
            });
                const sellerValues1 = this.allDate.map((item) => {
                return item[0].sTemperature
            });
                const sellerValues2 =this.allDate.map((item) => {
                return item[1].sTemperature
            });
            const dataOption = {
                title: {
                    text: ` ▎${this.allDate[0][0].sName.slice(0, 3)}热交换站温度环境`,
                    left: 20,
                    top: 20,
                },
                xAxis: {
                    data: sellerNames1,
                },
                series: [
                    {
                        data:  sellerValues1,
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        data: sellerValues2,
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    // {
                    //     data: abb2,
                    //     itemStyle: {
                    //         barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                    //     },
                    // },
                ],
            };
            this.chartInstance.setOption(dataOption);

        },
        startInterver() {
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            // 设置定时器2
            this.timerId = setInterval(() => {
                if (this.formattedTime == '30' || this.formattedTime == '00') {
                    this.getData()
                    this.updateChart();
                }
                this.time1()
            }, 1000);
        },
        // 浏览器发生变化时调用次方法，完成浏览器适配1
        screenAdapter() {
            const titleFontSize = (this.$refs.seller_erf.offsetWidth / 100) * 3.6;
            this.titleFontSize1 = titleFontSize
            const adapterOption = {
                title: {
                    textStyle: {
                        fontSize: titleFontSize,
                    },
                },
            };
            this.chartInstance.setOption(adapterOption);
            this.chartInstance.resize();
        },
    },
};
</script>
<style lang="less" scoped></style>